import { Controller } from 'stimulus'
import InfiniteScroll from 'infinite-scroll'

export default class InfiniteScrollsController extends Controller {
  container: InfiniteScroll

  connect() {
    this.container = new InfiniteScroll(this.element, {
      path: '.pagination__next',
      append: '.article',
      // enable button
      button: '.view-more-button',
      status: '.page-load-status',
      // disable loading on scroll
      loadOnScroll: false,
    })
  }
}
